import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const HeadContainer = styled.thead``;

interface HeadRowProps {
  templateColumns: string;
}

export const HeadRow = styled.tr<HeadRowProps>`
  display: grid;
  grid-template-columns: ${({ templateColumns }) => templateColumns};

  @media all and (max-width: ${layout.md}) {
    grid-template-columns: unset;
    display: flex;
    width: 100%;
  }
`;
